import {DataTableConfigInterface} from '../../../app/shared/components';

export const AuditTrailDataTableConfig: DataTableConfigInterface<any> = {
    dataSource: [],
    dataSourceKeys: [
        ['Date', 'Date'],
        ['User', 'User'],
        ['Old value', 'Old value'],
        ['New value', 'New value'],
    ],
    actionMenu: false
};
